import { createContext, useContext } from 'react';

import { ITutorialContext } from '../interfaces';

export const TutorialContext = createContext<ITutorialContext | undefined>(
  undefined,
);

// PulsingBorder consumers (e.g. UserAvatarButtonView) render on screens that
// sit outside TutorialProvider's scope (the pre-join AppHeader/
// DashboardAppHeader, the mobile HomeBottomBar) — useTutorial() must degrade
// to an inert default there instead of throwing.
const INERT_TUTORIAL_CONTEXT: ITutorialContext = {
  activeTutorialId: null,
  isTutorialRunning: false,
  activeHighlightTarget: null,
  activeKeyHint: null,
  activeStepText: null,
  hasNarrationStarted: false,
  completedTutorialIds: [],
  completedNoticeTutorialId: null,
  isPromptForced: false,
  startTutorial: () => {
    console.warn('startTutorial called outside of a TutorialProvider');
  },
  stopTutorial: () => {},
  openTutorialPrompt: () => {
    console.warn('openTutorialPrompt called outside of a TutorialProvider');
  },
  closeTutorialPrompt: () => {},
  dismissCompletionNotice: () => {},
};

/**
 * Reads the guided-tutorial context. Returns an inert default (no active
 * tutorial, no-op controls) when used outside a `TutorialProvider`.
 *
 * @returns Current tutorial state (active id, running flag, active highlight target) and the start/stop controls.
 */
export const useTutorial = (): ITutorialContext => {
  const context = useContext(TutorialContext);

  return context ?? INERT_TUTORIAL_CONTEXT;
};
